module.exports = __webpack_public_path__ + "static/media/sh.c147b9c0.svg";